import React, { useState } from 'react'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import { useSelector } from 'react-redux'
import ButtonStartIcon from '../../../../button/ButtonStartIcon'
import useAnalyticsCharts from '../../../../../hooks/setting/useAnalyticsCharts'
import AnalyticsChartsList from './List/List'
import AnalyticsChartDialog from './Dialog/Dialog'
import MenuOrderDialog from './MenuOrder/MenuOrderDialog'

const AnalyticsChart = () => {
  const [type, setType] = useState(null)
  const [form, setForm] = useState(null)
  const [ordering, setOrdering] = useState(false)
  const permission = useSelector((state) => state?.session?.permissions?.['analytics-chart'] || {})
  const list = useSelector((state) => state?.tenant?.analyticsCharts || [])
  const { isLoadingList } = useAnalyticsCharts()

  const onModal = (type = null, form = {}) => {
    setType(type)
    setForm(form)
  }

  return (
    <>
      <Box className='bg-primary text-primary-foreground px-4 py-1 flex gap-4 items-center justify-between sticky top-0 z-10 h-8'>
        <Typography variant='subtitle1' className='uppercase'>
          Analytics Charts
        </Typography>
        <Box className='flex gap-2 items-center'>
          {/* MF-554 — drag the menu into order instead of typing positions */}
          {!isLoadingList && permission?.updated && list.length > 1 && (
            <ButtonStartIcon
              onClick={() => setOrdering(true)}
              color='secondary'
              variant='contained'
              startIcon={['fas', 'grip-dots-vertical']}
            >
              Reorder menu
            </ButtonStartIcon>
          )}
          {!isLoadingList && permission?.created && (
            <ButtonStartIcon
              onClick={() => onModal('create', {})}
              color='secondary'
              variant='contained'
              startIcon={['fas', 'plus']}
            >
              Create
            </ButtonStartIcon>
          )}
        </Box>
      </Box>
      <Box className='px-2 py-2'>
        <AnalyticsChartsList
          isLoading={isLoadingList}
          list={list?.sort((a, b) => a.position - b.position) || []}
          permissions={permission}
          onModal={onModal}
        />
      </Box>
      <MenuOrderDialog open={ordering} onClose={() => setOrdering(false)} />
      {type && (
        <AnalyticsChartDialog type={type} show={!!type} onClose={() => onModal(null, {})} data={form || {}} />
      )}
    </>
  )
}

export default AnalyticsChart
